import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ListResponse } from '@ca/core/models';
import { Observable, of, zip } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ModuleSubmissionV1 } from '../models/module-submission-v1.model';
import { ModuleUpdate } from '../models/module-update.model';
import { ModuleV1Read } from '../models/module-v1-read.model';
import { ModulesV1Service } from './modules-v1.service';

@Injectable()
export class ModulesWorkspaceV1Service extends ModulesV1Service {
    apiUrl = 'module_manager/v1/workspace/modules';

    getWorkspaceModules(params?: HttpParams): Observable<ListResponse<ModuleV1Read>> {
        return this.http.get<ListResponse<ModuleV1Read>>(this.endpoint, { params, headers: { 'Content-Type': 'application/query.api+json' } }).pipe(
            switchMap((res: ListResponse<ModuleV1Read>) => {
                const ids = res.data.filter(module => module.producerId !== undefined).map(module => module.producerId);
                return zip(this.userService.getUserInfos$(ids), of(res));
            }),
            map(zipped => {
                const [userInfos, modules] = zipped;
                modules.data.forEach((module: ModuleV1Read) => {
                    module.author = userInfos.find(user => user.id === module.producerId);
                    module = new ModuleV1Read(module);
                });
                return modules;
            }),
        );
    }

    updateModule(updatedModel: ModuleUpdate): Observable<ModuleV1Read> {
        return this.http
            .patch<ModuleV1Read>(`${this.endpoint}/${updatedModel.id}`, updatedModel.moduleUpdates)
            .pipe(map((data: ModuleV1Read) => new ModuleV1Read(data)));
    }

    publishModule(submissionData: ModuleSubmissionV1): Observable<ModuleV1Read> {
        return this.http.post<ModuleV1Read>(`${this.endpoint}/${submissionData.moduleId}/submissions`, submissionData.submissionData);
    }

    protected createNewInstance(): ModuleV1Read {
        return new ModuleV1Read();
    }
}
